import { Bx, Input, Typo } from '@curry-group/mui-curcuma';
import { faSearch } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FramedContent } from '../../../components/framed-content';
import { ListWidget } from '../../../components/widget/list';
import { fetchSharepointsRequest } from '../../../data/reducer/detail';
import { transformForList } from '../../../model/ryve/Thing';

export const ConnectedSharepointManager = () => {
  const dispatch = useDispatch();

  const communicationId = useSelector(state => state.communication?.id);
  const userId = useSelector(state => state.foundation?.profile?.userId);
  const sharepoints = useSelector(state => state.detail.children.items);

  const detail = useSelector(state => state.detail.item);

  const [activeSharepoints, setActiveSharepoints] = useState<Array<any>>([]);

  const [filter, setFilter] = useState<string>('');

  useEffect(() => {
    if (communicationId) {
      dispatch(fetchSharepointsRequest({ parentId: communicationId }));
    }
  }, [communicationId, dispatch]);

  useEffect(() => {
    if (sharepoints) {
      const sortedSharepoints = sharepoints
        ?.filter(sharepoint => (sharepoint.content.sharepointActive || sharepoint.createdBy === userId));
      setActiveSharepoints(sortedSharepoints?.sort((a, b) => a.content?.title.localeCompare(b.content?.title)));
    }
  }, [sharepoints, userId]);

  return (
    <>
      <FramedContent>
        <Bx mb={2} display="flex" justifyContent="space-between">
          <Bx>
            <Input
              input={{
                value: filter,
                placeholder: 'Sharepoints suchen',
                onChange: event => setFilter(event.target.value),
                startAdornment: (
                  <Bx mr={1}>
                    <FontAwesomeIcon icon={faSearch} />
                  </Bx>
                )
              }}
            />
          </Bx>
        </Bx>
        <Bx>
          {(!activeSharepoints || activeSharepoints?.length === 0) && (
            <Bx mb={4}>
              <Typo variant="subtitle1">
                <strong>Aktuell keine Sharepoints vorhanden.</strong>
              </Typo>
            </Bx>
          )}
          {(!!activeSharepoints && activeSharepoints?.length > 0) && (
            <ListWidget
              headline={'Aktuelle Sharepoints'}
              items={transformForList(
                (activeSharepoints || []).map(item => {
                  return { _source: { ...item, content: { ...item.content, parentThing: detail } }, _id: item?._id, _score: 0 };
                })
              )}
              listType={'sharepoint'}
            />
          )}
        </Bx>
      </FramedContent>
    </>
  );
};
